import { Component, OnInit } from '@angular/core';
import { ProduitCrmService } from 'src/app/parametrage/core/service/produit-crm.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { transferArrayItem, moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { NatureProduitCrm } from 'src/app/parametrage/core/model/produitCrm/natureProduitCrm';
import { NatureProduitCrmChamp } from 'src/app/parametrage/core/model/produitCrm/NatureProduitCrmChamp';
import { ChampSourceProduitCrm } from 'src/app/parametrage/core/model/produitCrm/ChampSourceProduitCrm';

@Component({
  selector: "app-set-type-champ-produit-crm",
  templateUrl: "./set-type-champ-produit-crm.component.html",
  styleUrls: ["./set-type-champ-produit-crm.component.scss"]
})
export class SetTypeChampProduitCrmComponent implements OnInit {
  natureProduitCrmId: number;
  natureProduitCrm: NatureProduitCrm;
  natureProduitCrmChamps: NatureProduitCrmChamp[] = [];
  champSources: ChampSourceProduitCrm[] = [];

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _produitCrmService: ProduitCrmService
  ) {}

  ngOnInit() {
    this.getEmptyChampSourceProduitCrm(this.natureProduitCrmId);
    this.getNatureProduitCrmChamps();
  }

  getNatureProduitCrmChamps() {
    this._produitCrmService
      .getNatureProduitCrmChamps(this.natureProduitCrmId)
      .subscribe(data => {
        //order by position property
        if (data != null) {
          data.sort((a, b) => a.position - b.position);
        }
        this.natureProduitCrmChamps = data;
      });
  }

  getEmptyChampSourceProduitCrm(natureProduitCrmId: number) {
    this._produitCrmService
      .getEmptyChampSourceProduitCrm(natureProduitCrmId)
      .subscribe(data => {
        this.champSources = data;
      });
  }

  onSubmit() {
    if (this.natureProduitCrmChamps != null) {
      this.natureProduitCrmChamps.forEach(_ => {
        _.position = this.natureProduitCrmChamps.indexOf(_);
      });
    }
    this._produitCrmService
      .associerChamps(this.natureProduitCrmId, this.natureProduitCrmChamps)
      .subscribe(data => {
        this.activeModal.close();
      });
  }

  changeAfterChecked(value: any, champ: NatureProduitCrmChamp) {
    champ.obligatoire = value.checked;
    console.log(this.natureProduitCrmChamps);
  }

  drop(event: CdkDragDrop<NatureProduitCrmChamp[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    console.log(this.natureProduitCrmChamps);
  }
}
